<template>
    <div class="pokemon-container">
        <img :src="imgSrc"
        alt="pokemon"
        :class="!showPokemon ? 'hidden-pokemon' : ''">
        <!-- <img v-if="showPokemon"
        :src="imgSrc"
        alt="pokemon"
        class="fade-in"> -->
    </div>
    
</template>


<script>

//Number, required

export default {
    props: {
        pokemonId: {
            type: Number,
            required: true
        },
        showPokemon: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    computed: {
        imgSrc(){
            return `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/dream-world/${this.pokemonId}.svg`
        }
    }

}
</script>


<style scoped>
.pokemon-container {
    height: 200px;
    width: 500px;
    margin: auto;
    img {
        height: 200px;
        margin: auto 0px;
        user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -webkit-user-drag: none;
        -webkit-user-select: none;
        transition: all 1s ease;
    }
    .hidden-pokemon {
        filter: brightness(0);
        transition: all 1s ease;
    }

}


</style>